var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestoreNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_21766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9167 14.5C16.9167 13.1648 15.8352 12.0833 14.5 12.0833C13.1648 12.0833 12.0833 13.1648 12.0833 14.5C12.0833 15.8352 13.1648 16.9167 14.5 16.9167C15.8352 16.9167 16.9167 15.8352 16.9167 14.5ZM14.5 3.625C8.49458 3.625 3.625 8.49458 3.625 14.5H0L4.83333 19.3333L9.66667 14.5H6.04167C6.04167 9.82979 9.82979 6.04167 14.5 6.04167C19.1702 6.04167 22.9583 9.82979 22.9583 14.5C22.9583 19.1702 19.1702 22.9583 14.5 22.9583C12.6694 22.9583 10.9838 22.3723 9.59417 21.3815L7.88438 23.1154C9.72104 24.5292 12.0108 25.375 14.5 25.375C20.5054 25.375 25.375 20.5054 25.375 14.5C25.375 8.49458 20.5054 3.625 14.5 3.625Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_21766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestoreNew);
export default __webpack_public_path__ + "static/media/RestoreNew.01d40248335808fdc8bc047edf480515.svg";
export { ForwardRef as ReactComponent };